<template>
  <div class="feedbackInfo-page">
    <tabHeader
      :slideData="slideData"
      :tab="tab"
      @headerTabBack="headerTabBack"
    />
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <component
          :is="tab"
          :refresh="refresh"
          @jumpToSessionList="jumpToSessionList"
        ></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tabHeader from "@/components/tabHeader";
import sessionList from "./sessionList";
import blackList from "./blackList";
import statistics from "./statistics";
export default {
  components: {
    tabHeader,
    sessionList,
    blackList,
    statistics,
  },

  computed: {
    ...mapGetters([
      "userInfo",
      "addPopup",
      "ctrlItem",
      "buckets",
      "cbMsgList",
      "cbUserList",
    ]),
    slideData() {
      const slideData = [
        {
          name: "信息列表",
          component: "sessionList",
        },
        {
          name: "黑名单列表",
          component: "blackList",
        },
        {
          name: "统计",
          component: "statistics",
        },
      ];
      return slideData;
    },
  },
  data() {
    return {
      tab: "sessionList",
      refresh: false,
    };
  },
  methods: {
    headerTabBack(tab) {
      this.$router.push({
        name: "feedbackCbInfo",
      });
      this.tab = tab.component;
      this.refresh = new Date().getTime();
    },

    jumpToSessionList(data) {
      this.tab = "sessionList";
      this.$router.push({
        name: "feedbackCbInfo",
        query: { from: data.from, MsgKey: data.MsgKey },
      });
    },

    // ==================== 初始化CB =======================

    async initCb() {
      let res = await this.$http.getSyncToken({ userId: this.userInfo.id });
      this.$cookie.set(res.data.cookie_name, res.data.session_id);

      // await this.$store.dispatch("pullCbMsgList");
      this.$store.dispatch("initMsgCB");
      await this.$store.dispatch("getFeedbackUserFromDB");
    },
  },

  watch: {},

  destroyed() {
    // this.$cookie.remove("SyncGatewaySession");
  },
  async created() {
    this.initCb();
  },
};
</script>

<style lang="scss">
.feedbackInfo-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
